import Handlebars from 'handlebarsHelpers';
import { registerAssetsExtHelper } from './assetsExtHandlebarsHelper';

registerAssetsExtHelper(Handlebars);
